import React from 'react';
import { useRouter } from '../../components';
import { SiteLink } from '../../components';
//import BottomDrawer from '../../components/bottomDrawer'

export function BottomDock(props) {
  const links = [
    { url: '/infrastructure', title: 'Infrastructure & Transport', icon: 'navicon-about.png', iconHover: 'navicon-modular.png' },
    { url: '/defence', title: 'Defence & Security', icon: 'navicon-about.png', iconHover: 'navicon-modular.png' },
    { url: '/resources', title: 'Resources & Utilities', icon: 'navicon-about.png', iconHover: 'navicon-modular.png' },
    { url: '/renewable', title: 'Renewable Energy', icon: 'navicon-about.png', iconHover: 'navicon-modular.png' },
    { url: '/agritech', title: 'Agritech Solutions', icon: 'navicon-about.png', iconHover: 'navicon-modular.png' },
    { url: '/urban', title: 'Urban & Community', icon: 'navicon-about.png', iconHover: 'navicon-modular.png' },
    // { url: '/about', title: 'ABOUT', icon: 'navicon-about.png', iconHover: 'navicon-about.png' },
    // { url: '/construct', title: 'CONSTRUCT', icon: 'navicon-construct.png', iconHover: 'navicon-construct.png' },
    // { url: '/modular', title: 'MODULAR', icon: 'navicon-modular.png', iconHover: 'navicon-modular.png' },
    // { url: '/solar', title: 'SOLAR', icon: 'navicon-solar.png', iconHover: 'navicon-solar.png' },
    // { url: '/connect', title: 'CONNECT', icon: 'navicon-connect.png', iconHover: 'navicon-connect.png' }
  ];

  //const path = usePath();
  const { pathname } = useRouter();

  const isCurrent = (link) => {
    return pathname && pathname.toLowerCase() === link.toLowerCase();
  }

  const linkElts = links.map((link, index) =>
    <li key={index} className={`bottomMenu__li ${isCurrent(link.url) ? 'selected' : ''}`}>
      <SiteLink to={link.url} className={`bottomMenu__link bottomMenu__link--${index}`}>
        <div className="icon">
          <img className="normal" src={`/assets/navicons/${link.icon}`} alt={link.title} />
          <img className="selected" src={`/assets/navicons/${link.iconHover}`} alt={link.title} />
        </div>
        <div>{link.title}</div>
      </SiteLink>
    </li>
  );

  // const bottomMenu = useRef(null);
  // useLayoutEffect(() => {
  //   //console.log('useLayoutEffect');
  //   const slider = new BottomDrawer(bottomMenu.current);
  //   setTimeout(() => slider.init(), 1000)
  // }, [])

  // ref={bottomMenu}
  return (
    <>
      <nav className="bottomMenu">
        {/* <div className="bottomMenu__bar">
          <div className="bottomMenu__line1"></div>
          <div className="bottomMenu__line2"></div>
        </div> */}
        {/* <div className="bottomMenu__bg"></div> */}
        <ul className="bottomMenu__links">
          {linkElts}
        </ul>
      </nav>
      {/* <div className="bottomMenuPadding"></div> */}
    </>
  );
}
